import { render, staticRenderFns } from "./ClinincalList.vue?vue&type=template&id=5d653f88&scoped=true&"
import script from "./ClinincalList.vue?vue&type=script&lang=js&"
export * from "./ClinincalList.vue?vue&type=script&lang=js&"
import style0 from "./ClinincalList.vue?vue&type=style&index=0&id=5d653f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d653f88",
  null
  
)

export default component.exports